
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
@Component({
  components: { Dropdown, TextInput }
})
export default class TimePickerInput extends Vue {
  @Prop()
  value!: string;

  timePickerOpen = false;
}
